import { SVGProps } from 'react'

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.66667 13.7556H12.3333M8.18141 1.89232L2.52949 6.28826C2.15168 6.58211 1.96278 6.72904 1.82669 6.91304C1.70614 7.07603 1.61633 7.25964 1.56169 7.45487C1.5 7.67526 1.5 7.91457 1.5 8.3932V14.4223C1.5 15.3557 1.5 15.8224 1.68166 16.179C1.84144 16.4926 2.09641 16.7475 2.41002 16.9073C2.76654 17.089 3.23325 17.089 4.16667 17.089H13.8333C14.7668 17.089 15.2335 17.089 15.59 16.9073C15.9036 16.7475 16.1586 16.4926 16.3183 16.179C16.5 15.8224 16.5 15.3557 16.5 14.4223V8.3932C16.5 7.91457 16.5 7.67526 16.4383 7.45487C16.3837 7.25964 16.2939 7.07603 16.1733 6.91304C16.0372 6.72904 15.8483 6.58211 15.4705 6.28826L9.81859 1.89232C9.52582 1.66461 9.37943 1.55076 9.21779 1.50699C9.07516 1.46837 8.92484 1.46837 8.78221 1.50699C8.62057 1.55076 8.47418 1.66461 8.18141 1.89232Z"
      stroke="#667085"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
